module.exports = __webpack_public_path__ + "static/media/staff_Jack.a48df099.svg";